<template>
  <div v-if="showAlertForSmallScreen" class="alert-small-screen">
    <p>This site is only supported on larger screens. Please use a desktop or maximize your browser window.</p>
  </div>
  <div v-show="!showAlertForSmallScreen" class="main">
    <div v-if="!hasLogined()" class="loadbar">
      <h1 class="wait-title">
        <b style="color: #A51C30">A</b><b style="color: #A51C30">GE</b><b style="color: #e42b3d">S</b>
      </h1>
      <h4 class="red">
        You Must Login First
      </h4>
      <a class="resource" href="mailto:alek0991@gmail.com">Contact Your Supervisor</a>
    </div>
    <div v-if="hasLogined()">

      <div
        style="background-color: #A51C30; top: 60px; width: 100vw; text-align: center;border: 1px solid #A51C30; padding: 10px; position: fixed; z-index: 999;">
        <span style="font-size: 16px;">
          <b style="color: white;">
            This website is currently in its beta phase and undergoing active development. For any questions or feedback, please contact 
            <a style="color: white; text-decoration-color: white;"
              href="mailto:&#97;&#108;&#105;&#95;&#97;&#107;&#98;&#97;&#114;&#105;&#64;&#102;&#97;&#115;&#46;&#104;&#97;&#114;&#118;&#97;&#114;&#100;&#46;&#101;&#100;&#117;">ali_akbari@fas.harvard.edu</a>.
          </b>
        </span>
      </div>
      <div class="boxtitle">
        <div class="title">
          <div>
            <span style="font-size: 35px;"><b style=" color: #A51C30;">AGES:</b> <b style=" color: #A51C30;">A</b>ncient
              <b style=" color: #A51C30;">GE</b>nome <b style=" color: #A51C30;">S</b>election</span>
            <p>Tracing Directional Selection in Human Populations of Western Eurasia Over the Past 10,000 Years Through
              Ancient DNA</p>
          </div>
        </div>
      </div>

      <div id="plotManhattanContainer">
        <div id="manhLoader" v-if="computation.manhattan == 'PROCESS'" style="background-color: rgba(0, 0, 0, 0.0);">
          <scale-loader :loading="gridLoading" :color="gridColor" :size="gridSize"></scale-loader>
          <h5 style="margin-top: 10px">Loading Data... This should take only a few seconds.</h5>
        </div>
        <div id="manhContainer" :style="{
          'filter': computation.manhattan === 'PROCESS' ? 'blur(18px) contrast(80%)' : 'none', 'background-color': computation.manhattan === 'PROCESS' ? 'rgba(0, 0, 150, 0.2)' : 'white',
          'opacity': computation.manhattan === 'PROCESS' ? 0.3 : 1
        }">
          <span class="info-plot-redirect" @click="infoManhattan()">
            <span class="material-symbols-outlined">info</span>
          </span>
          <div id="manhattan-plot" style="width: 900px; height:230px;"></div>
        </div>
      </div>
      <div class="explanation-box" :style="{
        'filter': computation.manhattan === 'PROCESS' ? 'blur(18px) contrast(80%)' : 'none', 'background-color': computation.manhattan === 'PROCESS' ? 'rgba(0, 0, 150, 0.2)' : 'white',
        'opacity': computation.manhattan === 'PROCESS' ? 0.0 : 1
      }">
      </div>
      <div class="enginebox">
        <engine class="engine" />
      </div>
      <div class="examplebox">
  <div class="example-content">
    <strong>Search Examples:</strong>
    <ul>
      <li>Gene: <mark>LCT</mark></li>
      <li>Transcript: <mark>ENST00000264162</mark></li>
      <li>Protein: <mark>ENSP00000264162</mark></li>
      <li>Variant: <mark>2_136608646_G_A</mark> or <mark>2_136608646</mark></li>
      <li>RSID: <mark>rs4988235</mark></li>
    </ul>
    <p>
      You can search using any of the above identifiers or click directly on the Manhattan plot.
      <br />
    </p>
  </div>
</div>


    </div>
  </div>

</template>

<script>
import axios from "axios";
import Engine from "@/components/Engine.vue";
import { isValidToken } from "@/utils/login.js"
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { buildManhattanPlot } from '@/plots/manhattan/scatter.js';
import { smallScreenMixin } from '@/mixins/smallScreenMixin';
import Swal from "sweetalert2";


export default {
  name: "SearchAutocomplete",
  mixins: [smallScreenMixin],
  data() {
    return {
      computation: { 'manhattan': 'PROCESS' },
      gridLoading: "loading",
      gridColor: "#A51C30",
      gridSize: "60px",
      isServerDown: false,
    }
  },
  components: {
    Engine,
    ScaleLoader
  },
  methods: {
  serverDownError() {
      Swal.fire({
        title: '<p style="font-family:Ubuntu">Server Error<p>',
        html: '<p style="font-family:Ubuntu; font-size: 16px;">The server is currently down. If you’re seeing this page, please contact us via email.</p>',
        icon: 'error',
        confirmButtonText: 'Okay',
        iconColor: '#A51C30',
        customClass: {
          title: 'swal-title',
          text: 'swal-text',
          confirmButton: 'swal-confirm-button',
        }
      });
    },
    serverDownError() {
      Swal.fire({
        title: '<p style="font-family:Ubuntu">Server Error<p>',
        html: '<p style="font-family:Ubuntu; font-size: 16px;">The server is currently down. If you’re seeing this page, please contact us via email.</p>',
        icon: 'error',
        confirmButtonText: 'Okay',
        iconColor: '#A51C30',
        customClass: {
          title: 'swal-title',
          text: 'swal-text',
          confirmButton: 'swal-confirm-button',
        }
      });
    },
    infoManhattan() {
      Swal.fire({
        width: 945,
        customClass: {
          title: "swal-title",
          text: "swal-text",
          confirmButton: "swal-confirm-button",
        },
        confirmButtonColor: "#A51C30",
        confirmButtonText: "Close",
        title:
          '<h6 style="font-family: Ubuntu; font-size: 20px;">Interactive Manhattan Plot</h6>',
          html: `<p style="text-align: left; font-family: Ubuntu; font-size: 15px; text-align: justify; line-height: 28px;">
          This interactive Manhattan plot highlights the signature of natural selection in the human genome within Western Eurasian populations, which include both European and Near Eastern groups, over the past 10,000 years. Each point on the plot represents a genetic variant, such as a single nucleotide polymorphism (SNP) or a small insertion/deletion.
          </p>
        <br>

          <p style="text-align: left; font-family: Ubuntu; font-size: 15px; text-align: justify; line-height: 28px;">
          The x-axis displays the location of each variant on the chromosomes, while the y-axis indicates the strength of the evidence for natural selection. The higher a point appears on the y-axis, the stronger the indication that the variant has been influenced by natural selection.
          </p>
        <br>
          <p style="text-align: left; font-family: Ubuntu; font-size: 15px; text-align: justify; line-height: 28px;">
          To ensure that the results are not biased by factors such as genetic differences or population admixture, we apply a method that accounts for genetic similarities. For further information on how the y-axis values were calculated, please refer to our publication, <a style="color: #A51C30; text-decoration: none;" target="_blank" href="http://doi.org/10.1101/2024.09.14.613021">Akbari et al. (2024)</a>.
          </p>`
      });
    },
    hasLogined() {
      return isValidToken(localStorage.getItem('ages_hms_access_token'))
    },
    manhattanClickHandler(item) {
      const id = item.data[2]
      let routeData = this.$router.resolve({
        name: "Charts",
        params: { id },
      });
      window.open(routeData.href, "_blank");
    },
    axiosHandler() {
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_ROOT_API,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('ages_hms_access_token')}`,
        },
      });
      return axiosInstance
    },
    async cleanupIndexedDB() {
      const dbToKeep = 'ManhattanPlotDB_01OCT2025';

      try {
        const allDbs = await indexedDB.databases();

        const dbsToDelete = allDbs.filter(db => db.name !== dbToKeep);

        if (dbsToDelete.length === 0) {
          console.log('No other databases to delete.');
          return;
        }

        const deletionPromises = dbsToDelete.map(db => {
          return indexedDB.deleteDatabase(db.name);
        });

        await Promise.all(deletionPromises);
      } catch (error) {
        console.error('Error during database cleanup:', error);
      }
    },
    openDb() {
      this.cleanupIndexedDB();
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('ManhattanPlotDB_01OCT2025', 1);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          db.createObjectStore('manhattanDataCache', { keyPath: 'id' });
        };

        request.onsuccess = (event) => {
          resolve(event.target.result);
        };

        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    },
    saveData(data) {
      return this.openDb().then((db) => {
        return new Promise((resolve, reject) => {
          const transaction = db.transaction('manhattanDataCache', 'readwrite');
          const store = transaction.objectStore('manhattanDataCache');
          const request = store.put({ id: 'manhattan', data });

          request.onsuccess = () => {
            resolve();
          };

          request.onerror = (event) => {
            reject(event.target.error);
          };
        });
      });
    },
    getData() {
      return this.openDb().then((db) => {
        return new Promise((resolve, reject) => {
          const transaction = db.transaction('manhattanDataCache', 'readonly');
          const store = transaction.objectStore('manhattanDataCache');
          const request = store.get('manhattan');

          request.onsuccess = (event) => {
            if (event.target.result) {
              resolve(event.target.result.data);
            } else {
              resolve(null);
            }
          };

          request.onerror = (event) => {
            reject(event.target.error);
          };
        });
      });
    }
  },
  mounted() {
    let manhContainer = document.getElementById("manhattan-plot");
    this.getData().then((cachedData) => {
      if (cachedData) {
        buildManhattanPlot(manhContainer, cachedData, this.manhattanClickHandler);
        this.computation['manhattan'] = 'FINISH';
      } else {
        this.axiosHandler()
          .get(`/api/get-manhattan-json`)
          .then((response) => {

            this.isServerDown = false;
            if (Swal.isVisible()) Swal.close();

            buildManhattanPlot(manhContainer, response.data.manhattan, this.manhattanClickHandler);
            this.computation['manhattan'] = 'FINISH';
            return this.saveData(response.data.manhattan);
          })
          .catch((error) => {
            if (!this.isServerDown) { // Only show error once
              this.isServerDown = true;
              this.serverDownError(); // Assumes you added this method
            }
          });
      }
    });
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200");

.main {
  position: relative;
  margin-top: 80px;
}

@media only screen and (max-width: 767px) {
  .main {
    padding: 40px 32px;
  }
}

.main p {
  margin: 10px 0;
  font-size: 15.5px;
}

.examplebox {
  width: 100vw;
  display: flex;
  justify-content: center;
  margin-top: 0;
}

.example-content {
  width: 945px;
  font-size: 15px;
  line-height: 1.7;
  background-color: #ffffffff;
  border: 1px solid #ffffffff;
  border-radius: 8px;
  padding: 20px;
}

.example-content ul {
  margin-top: 8px;
  margin-bottom: 12px;
  padding-left: 20px;
}

.example-content li {
  margin-bottom: 6px;
}

.example-content mark {
  background-color: #f3f3f1;
  padding: 2px 5px;
  border-radius: 4px;
}

.enginebox {
  width: 100vw;
  display: flex;
  position: relative;
  flex-direction: columns;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.explanation-box {
  width: 100vw;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 !important;
}

.explanation {
  text-align: justify;
  position: relative;
  top: -15px;
  width: 945px;
  font-size: 14px !important;
}

.explanation-title {
  text-align: justify;
  position: relative;
  top: -5px;
  width: 945px;
  display: flex;
  font-weight: bold;
  font-size: 20px !important;
  justify-content: flex-start;
}



.boxtitle {
  width: 100vw;
  display: flex;
  justify-content: center;
  margin-top: 100px;
}

.title {
  display: flex;
  width: 950px;
  margin-top: 50px;
  flex-direction: row;
  justify-content: flex-start;
}

.title img {
  width: 78px;
  height: 78px;
  margin-right: 5px;
}

.hint {
  padding-left: 40px;
}

.hint li {
  color: rgb(60, 60, 60);
  margin-top: 8px;
}

mark {
  background-color: #F3F3F1;
  padding: 0 3px;
  border-radius: 4px;
}

.loadbar {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.loadbar h4 {
  margin-bottom: 0.8rem;
  font-size: 28px;
}

.red {
  color: rgb(230, 22, 71);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem !important;
}

.resource {
  color: #A51C30;
  text-decoration: none;
  margin-left: 0.3rem;
  font-size: 15px;
}

.wait-title {
  font-size: 60px;
}

#plotManhattanContainer {
  height: 200px;
  width: 950px;
  position: relative;
  display: flex;
  margin: 50px auto;
  justify-content: center;
  align-items: center;
}

#manhLoader {
  position: absolute;
}

#manhContainer {
  position: relative;
  padding: 20px;
  background-color: rgba(63, 109, 237, 0.005) !important;
  border: 1.4px solid #A51C30;
  border-radius: 5px;
}

.alert-small-screen {
  font-size: 1.3rem;
  width: 90vw;
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-plot-redirect {
  position: absolute;
  top: 24px;
  right: 28px;
  cursor: pointer;
  z-index: 999;
}

.info-plot-redirect .material-symbols-outlined {
  font-size: 21px;
  color: #A51C30;
  cursor: pointer;
  z-index: 1;
}

.swal-confirm-button {
  background-color: #A51C30 !important;
  color: white !important;
  border: none !important;
  outline: none !important;
  box-shadow: 0 0 5px #a51c316b !important;
  font-family: Ubuntu;
}
</style>
